import React, { useState, useEffect } from 'react';
import { Box, Modal, IconButton } from '@mui/material';
import { ArrowBack, ArrowForward, Close } from '@mui/icons-material';
import Carousel from 'react-material-ui-carousel';

const FlyerSlideshow = () => {
  const [flyers, setFlyers] = useState([
    // You'll need to add your flyer images to the /public/flyers directory
    // and then list them here
    '/flyers/freesundayherbtea.jpg',
    '/flyers/limitedtimepackages.jpg',
    '/flyers/newweeklyschedule.jpg',
  ]);
  
  const [open, setOpen] = useState(false);
  const [selectedFlyer, setSelectedFlyer] = useState('');
  
  const handleOpen = (flyer) => {
    setSelectedFlyer(flyer);
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };
  
  return (
    <Box sx={{ my: 4 }}>
      <Carousel
        animation="slide"
        navButtonsAlwaysVisible
        indicators={true}
        navButtonsProps={{
          style: {
            backgroundColor: 'rgba(76, 175, 80, 0.6)',
            borderRadius: 0
          }
        }}
      >
        {flyers.map((flyer, index) => (
          <Box 
            key={index}
            onClick={() => handleOpen(flyer)}
            sx={{ 
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              height: '700px',
              '&:hover': { opacity: 0.9 }
            }}
          >
            <img 
              src={flyer} 
              alt={`Promotional flyer ${index + 1}`}
              style={{ 
                height: '100%',
                maxWidth: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>
        ))}
      </Carousel>
      
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="flyer-modal"
        aria-describedby="enlarged flyer view"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '800px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 1,
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <IconButton 
            onClick={handleClose}
            sx={{ 
              position: 'absolute', 
              right: 8, 
              top: 8,
              backgroundColor: 'rgba(0,0,0,0.1)',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.2)' }
            }}
          >
            <Close />
          </IconButton>
          <Box sx={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'auto'
          }}>
            <img 
              src={selectedFlyer} 
              alt="Enlarged flyer"
              style={{ 
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain'
              }}
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default FlyerSlideshow;